import { IGameState } from "State/Game/IGameState";
import { ResourceActionTypeValueType, SOFALevelMetricsCount, SOFAResourceInventory, SOFAResourceUpdates } from "./Avo";
import { TrackingDataSet } from "../Track";
import { TransactionType } from "../DataSet/Transaction";

export function getLevelMetricsCount(params: TrackingDataSet): SOFALevelMetricsCount[] {
    return [
        {
            sofaLevelMetric: "Cards Left in Stack",
            amount: params.mMovesLeft,
        },
        {
            sofaLevelMetric: "Cards Left on Board",
            amount: params.mCardsLeftOnBoard,
        },
        {
            sofaLevelMetric: "Stars Achieved",
            amount: params.mStars,
        },
    ];
}

export function getResourceInventory(state: IGameState): SOFAResourceInventory[] {
    return [
        {
            sofaResourceType: "Coins",
            amount: state.playerState.inventory.coins,
        },
        {
            sofaResourceType: "Booster Canister",
            amount: state.playerState.inventory.boosterTNT,
        },
        {
            sofaResourceType: "Booster Joker",
            amount: state.playerState.inventory.boosterJoker,
        },
        {
            sofaResourceType: "Booster Plus 5 Cards",
            amount: state.playerState.inventory.boosterPlusFive,
        },
        {
            sofaResourceType: "Booster Pre-level Canister",
            amount: state.playerState.inventory.preBoosterCanister,
        },
        {
            sofaResourceType: "Booster Pre-level Joker",
            amount: state.playerState.inventory.preBoosterJoker,
        },
        {
            sofaResourceType: "Booster Pre-level Remove Three",
            amount: state.playerState.inventory.preBoosterRemoveThree,
        },
        {
            sofaResourceType: "Booster Shuffle",
            amount: state.playerState.inventory.boosterShuffle,
        },
        {
            sofaResourceType: "Booster Slingshot",
            amount: state.playerState.inventory.boosterBullseye,
        },
        {
            sofaResourceType: "Booster Undo",
            amount: state.playerState.inventory.boosterUndo,
        },
        {
            sofaResourceType: "Free Level Entry",
            amount: state.playerState.inventory.free_play,
        }
    ];
}

export function getResourceUpdates(params: TrackingDataSet): SOFAResourceUpdates[] {
    return [
        {
            sofaResourceType: "Coins",
            amount: getNormalizedResourceUpdate(params.tCoinsReceived, params.tCoinsUsed),
        },
        {
            sofaResourceType: "Booster Canister",
            amount: getNormalizedResourceUpdate(params.tMassRemoveReceived, params.tMassRemoveUsed),
        },
        {
            sofaResourceType: "Booster Joker",
            amount: getNormalizedResourceUpdate(params.tJokerReceived, params.tJokerUsed),
        },
        {
            sofaResourceType: "Booster Plus 5 Cards",
            amount: getNormalizedResourceUpdate(params.tPlus5Received, params.tPlus5Used),
        },
        {
            sofaResourceType: "Booster Pre-level Canister",
            amount: getNormalizedResourceUpdate(params.tCanisterCardBoostersReceived, params.tCanisterCardBoostersUsed),
        },
        {
            sofaResourceType: "Booster Pre-level Joker",
            amount: getNormalizedResourceUpdate(params.tExtraWildcardsBoostersReceived, params.tExtraWildcardsBoostersUsed),
        },
        {
            sofaResourceType: "Booster Pre-level Remove Three",
            amount: getNormalizedResourceUpdate(params.tRemoveCardsBoostersReceived, params.tRemoveCardsBoostersUsed),
        },
        {
            sofaResourceType: "Booster Shuffle",
            amount: getNormalizedResourceUpdate(params.tChangerReceived, params.tChangerUsed),
        },
        {
            sofaResourceType: "Booster Slingshot",
            amount: getNormalizedResourceUpdate(params.tRemoveOneReceived, params.tRemoveOneUsed),
        },
        {
            sofaResourceType: "Booster Undo",
            amount: getNormalizedResourceUpdate(params.tUndoReceived, params.tUndoUsed),
        },
        {
            sofaResourceType: "Free Level Entry",
            amount: getNormalizedResourceUpdate(params.tFreeEntryReceived, params.tFreeEntryUsed),
        }
    ];
}

export function getLevelResourceUpdates(params: TrackingDataSet): SOFAResourceUpdates[] {
    return [
        {
            sofaResourceType: "Coins",
            amount: getNormalizedResourceUpdate(params.mCoinsReceived, params.mCoinsSpent),
        },
        {
            sofaResourceType: "Booster Canister",
            amount: getNormalizedResourceUpdate(0, params.mMassRemoveUsed),
        },
        {
            sofaResourceType: "Booster Joker",
            amount: getNormalizedResourceUpdate(0, params.mJokerUsed),
        },
        {
            sofaResourceType: "Booster Plus 5 Cards",
            amount: getNormalizedResourceUpdate(0, params.mPlus5Used),
        },
        {
            sofaResourceType: "Booster Pre-level Canister",
            amount: getNormalizedResourceUpdate(0, params.mCanisterCardBoostersUsed),
        },
        {
            sofaResourceType: "Booster Pre-level Joker",
            amount: getNormalizedResourceUpdate(0, params.mExtraWildcardsBoostersUsed),
        },
        {
            sofaResourceType: "Booster Pre-level Remove Three",
            amount: getNormalizedResourceUpdate(0, params.mRemoveCardsBoostersUsed),
        },
        {
            sofaResourceType: "Booster Shuffle",
            amount: getNormalizedResourceUpdate(0, params.mChangerUsed),
        },
        {
            sofaResourceType: "Booster Slingshot",
            amount: getNormalizedResourceUpdate(0, params.mRemoveOneUsed),
        },
        {
            sofaResourceType: "Booster Undo",
            amount: getNormalizedResourceUpdate(0, params.mUndoUsed),
        },
        {
            sofaResourceType: "Free Level Entry",
            amount: getNormalizedResourceUpdate(0, params.mFreeEntryUsed),
        },
    ];
}

export function getResourceActionType(params: any): ResourceActionTypeValueType {
    return {
        [TransactionType.REWARD]: 'Reward',
        [TransactionType.COIN_PURCHASE]: 'Coin_Purchase',
        [TransactionType.PURCHASE]: 'Purchase',
        [TransactionType.AD]: 'Ad',
        [TransactionType.INVENTORY]: 'Inventory',
        [TransactionType.LEVEL_END]: 'Level_End',
        [TransactionType.LUCKY_TURNIPS_CLAIM]: 'Lucky_Turnips_Claim',
        [TransactionType.PET]: 'Pet',
    }[params.transactionType as string] as ResourceActionTypeValueType;
}

function getNormalizedResourceUpdate(received: number, used: number): number {
    return received ? received : used ? -used : 0;
}
